import React, { useState } from 'react';
import SignUpForm from './SignUpForm';
import SignInForm from './SignInForm';
import { FaInfoCircle } from "react-icons/fa";


const Log = ( props) => {
const [signUpModal, setSignUpModal] = useState(props.signup);
const [signInModal, setSignInModal] = useState(props.signin);

const handleModals = (e) => {
    if(e.target.id === "register") {
        setSignInModal(false);
        setSignUpModal(true)
    }
    else if(e.target.id === "login") {
        setSignInModal(true);
        setSignUpModal(false);
    }
}

    return (
        <div>
            <div className="infoConnect">
                <FaInfoCircle />
                <span>Pour créer des annonces, il est nécessaire de posséder un compte utilisateur.</span>
            </div>
            <div className='buttonConnectRegister'>
                <ul>
                    <li onClick={handleModals} id='register' className={signUpModal ? 'active-btn button' : 'button'}>S'inscrire</li>
                    <li onClick={handleModals} id='login' className={signInModal ? 'active-btn button' : 'button'}>Se connecter</li>
                </ul>
                {signInModal && <h3>Vous possédez déjà un compte utilisateur : </h3>}
                {signUpModal && <h3>Vous ne possédez pas encore de compte utilisateur : </h3>}
                {signUpModal && <SignUpForm />}
                {signInModal && <SignInForm />}
            </div>
        </div>
    );
};

export default Log;